import PropTypes from 'prop-types'
import React, { Component } from 'react'
import styles from './_friendGlobal.css'
import { FormattedMessage } from 'react-intl'
import Button from 'components/util/Button'
import Loader from 'components/util/Loader'

export default class FriendSuggested extends Component {
  static propTypes = {
    friendInfo: PropTypes.object,
    addFriendAction: PropTypes.func,
    idInLoadingState: PropTypes.number,
  }

  handleAddFriend = () => {
    const { friendInfo } = this.props
    this.props.addFriendAction(friendInfo)
  }

  render () {
    const { friendInfo, idInLoadingState } = this.props

    const basicUserInfo = {
      displayName: friendInfo.display_name,
      id: friendInfo.id,
      location: friendInfo.location || {},
    }

    const profile = `/profile/${basicUserInfo.id}`
    const profileImage = `${profile}/picture?size=Medium`
    const loadingState = friendInfo.id === idInLoadingState

    return (
      <div className={styles.friendContainer}>
        <div className={styles.friendInner}>
          <a href={profile}>
            <img className={styles.profileImage} src={profileImage} />
          </a>
          <div className={styles.friendName}>
            <a href={profile}>{basicUserInfo.displayName}</a>
            {Object.keys(basicUserInfo.location).length ?
              <div className={styles.friendLocation}>
                <FormattedMessage
                  id='friends.suggested.location'
                  defaultMessage='{locality}, {region}'
                  values={{
                    locality: basicUserInfo.location.locality,
                    region: basicUserInfo.location.region,
                  }}
                />
              </div> : null}
          </div>
          {!loadingState ?
            <Button
              size='small'
              type='secondary'
              el='button'
              onClick={this.handleAddFriend}>
              <FormattedMessage
                id='friends.addsuggested'
                defaultMessage='Add'
              />
            </Button> : <Loader type='spin' height={25} width={25} />}
        </div>
      </div>
    )
  }
}
